import React, { useState, useEffect, useReducer, useRef, useMemo } from "react";
import {
  Tabs,
  Tab,
  Grid,
  Box,
  Card,
  IconButton,
  Input,
  InputAdornment,
  Typography,
  Stack,
} from "@mui/material";
import dayjs from "dayjs";
import { get } from "aws-amplify/api";
import {
  DataGrid,
  GridToolbarContainer,
  GridActionsCellItem,
  GridToolbarColumnsButton,
  GridRowModes,
  useGridApiRef,
} from "@mui/x-data-grid";
import { I18n } from "@aws-amplify/core";
import { fetchAuthSession } from "@aws-amplify/core";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import currentUserToken from "CurrentUserToken";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import SearchIcon from "@mui/icons-material/Search";
import { useTheme } from "@mui/material/styles";
import Tooltip from "@mui/material/Tooltip";
import EditUser from "popup/EditUser";
import EditPermission from "popup/EditPermission";
import { useNavigate } from "react-router-dom"; // Import useNavigate for navigation
import { GridToolbarExport, GridToolbarFilterButton } from "@mui/x-data-grid";
import { DataGridPro } from "@mui/x-data-grid-pro/DataGridPro";
import { itIT } from "@mui/x-data-grid/locales";
import { deDE } from "@mui/x-data-grid/locales";
import { useTemplateController } from "context";
const reducer = (lastState, action) => {
  if (action.type === "DATA_RECEIVED") {
    return { audit: action.value, fetched: true };
  }
  return lastState;
};
const reducer2 = (lastState, action) => {
  if (action.type === "DATA_RECEIVED") {
    return { audit: action.value, fetched: true };
  }
  return lastState;
};
function Profile ()  {
  const [controller]=useTemplateController();
  const{darkMode}=controller;
  const [state, dispatch] = useReducer(reducer, { audit: [], fetched: false });
  const [state2, dispatch2] = useReducer(reducer2, {
    audit: [],
    fetched: false,
  });
  const [selectedUser, setSelectedUser] = useState(null);
  const [editUserOpen, setEditUserOpen] = useState(false);
  const [editPermissionOpen, setPermissionOpen] = useState(false);
  const [resizeThrottle, setResizeThrottle] = useState(60);
  const [filters, setFilters] = useState({});
  const [totalCount, setTotalCount] = useState(0);
  const handleSaveUser = (updatedUser) => {
    const updatedAudit = state.audit.map((user) =>
      user.user_id === updatedUser.user_id ? updatedUser : user
    );
    dispatch({ type: "DATA_RECEIVED", value: updatedAudit });
  };
  const [languages, setLanguages] = useState([]);
  const [profile, setProfile] = useState("");
  const [groupNameSel, setGroupNameSel] = useState(""); // State to store selected group name
  const [profileUser, setProfileUser] = useState("");
  const [userId, setUserId] = useState("");
  const [profilePermission, setProfilePermission] = useState("");
  const [language, setLanguage] = useState(
    localStorage.getItem("language") || "en"
  );
  const [tableParentIsMD, setTableParentIsMD] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const toolbarRef = useRef(null);
  const [userInfo, setUserInfo] = useState({
    email: "",
    name: "",
    profiles: ["NOT ADMIN"],
  });
  useEffect(() => {
    async function currentSession() {
      try {
        const { accessToken, idToken } =
          (await fetchAuthSession()).tokens ?? {};
        const profiles = await tlmGetUserGroups(
          idToken.payload["cognito:username"]
        );

        setUserInfo({
          name: idToken.payload.name || "No Name",
          email: idToken.payload.email || "No email",
          profiles: profiles || [],
        });
        // Save profiles to setProfile
        setProfile(profiles);
      } catch (err) {}
    }

    currentSession();
  }, []);
  useEffect(() => {
    const currentPath = window.location.pathname;
    if (currentPath.includes("/settings")) {
      setTabValue(0);
    } else if (currentPath.includes("/uncoded")) {
      setTabValue(1);
    }
  }, []);
  useEffect(() => {
    const parentElement = toolbarRef.current;
    if (!parentElement) {
      console.error("toolbarRef is not correctly attached to any DOM element.");
      return;
    }
    const checkSize = (width) => {
      const breakpoint = 960; // 960px is md
      setTableParentIsMD(width < breakpoint);
    };
    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        checkSize(entry.contentRect.width);
      }
    });
    resizeObserver.observe(parentElement);
    checkSize(parentElement.offsetWidth);
    return () => {
      resizeObserver.disconnect();
    };
  }, []);
  const apiRef = useGridApiRef();
  const [searchText, setSearchText] = useState("");
  const [rowModesModel, setRowModesModel] = useState({});
  const searchChanged = (event) => {
    setSearchText(event.target.value);
  };
  useEffect(() => {
    const hiddenColumns = JSON.parse(
      localStorage.getItem("hiddenColumns") || "[]"
    );
    if (apiRef.current) {
      apiRef.current.setColumnVisibilityModel(
        hiddenColumns.reduce((model, field) => {
          model[field] = false;
          return model;
        }, {})
      );
    }
  }, [apiRef]);
  const handleColumnVisibilityChange = (newModel) => {
    const hiddenColumns = Object.keys(newModel).filter(
      (field) => !newModel[field]
    );
    localStorage.setItem("hiddenColumns", JSON.stringify(hiddenColumns));
  };
  const filteredRows = state.audit.filter((value) => {
    if (searchText) {
      const searchTextLower = searchText.toLowerCase();
      return Object.values(value).some((val) =>
        String(val).toLowerCase().includes(searchTextLower)
      );
    }
    return true;
  });
  const filteredRowsCount = filteredRows.length;

  // Effect to get user profiles and set group name dynamically
  const tlmGetUserGroups = async (userID) => {
    try {
      const restOperation = get({
        apiName: "TelemonitoringAPI",
        path: "/userManagement/user/groups",
        options: {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${await currentUserToken()}`,
          },
          queryParams: { user_id: userID },
        },
      });
      const { body } = await restOperation.response;
      const response = await body.json();
      setProfile(response.profiles.map((profile) => profile.group_name) || []);
      // Extract profiles from the response and set groupNameSel with the first profile
      const profiles = response.profiles.map((profile) => profile.group_name);

      if (profiles.length > 0) {
        setGroupNameSel(profiles[0]); // Set default selected profile
      }

      dispatch2({ type: "DATA_RECEIVED", value: profiles });
    } catch (error) {
      console.error("Error fetching user groups:", error);
    }
  };

  const tlmGetAllUsers = async () => {
    try {
      const restOperation = get({
        apiName: "TelemonitoringAPI",
        path: "/userManagement/user/list",
        options: {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${await currentUserToken()}`,
          },
        },
      });
      const { body } = await restOperation.response;
      const response = await body.json();
      if (response.length > 0) {
        const userProfile = response[0].user_profile; // Adjust based on your API response structure
        setProfilePermission(userProfile);
      }
      dispatch({ type: "DATA_RECEIVED", value: response });
    } catch (error) {
      console.error("Errore durante la chiamata API:", error);
    }
  };
  useEffect(() => {
    tlmGetAllUsers();
  }, []);
  useEffect(() => {
    const tlmGetLanguagesAPI = async () => {
      try {
        const restOperation = get({
          apiName: "TelemonitoringAPI",
          path: "/languages",
          options: {
            headers: {
              "Content-Type": "application/json",
              Authorization: `${await currentUserToken()}`,
            },
            queryParams: {},
          },
        });
        const { body } = await restOperation.response;
        const response = await body.json();
        setLanguages(response);
      } catch (error) {
        console.error("Errore durante la chiamata API:", error);
      }
    };
    tlmGetLanguagesAPI();
  }, []);
  const columns = useMemo(
    () => [
      { field: "user_id", headerName: I18n.get("User ID"), width: 300 },
      {
        field: "user_email",
        headerName: I18n.get("Email"),
        width: 300,
        renderCell: (params) => (
          <Typography
            component="a"
            href={`mailto:${params.value}`}
            sx={{
              fontSize: "medium",
              cursor: "pointer",
              textDecoration: "underline",
            }}
          >
            {params.value}
          </Typography>
        ),
      },
      { field: "user_name", headerName: I18n.get("Name"), width: 300 },
      { field: "user_profile", headerName: I18n.get("Profile"), width: 250 },
      {
        field: "tlm_app_registration_date",
        headerName: I18n.get("Registration Date"),
        width: 300,

        valueFormatter: (value) => {
          if (!value) {
            return ""; // Handle null or undefined values
          }
          const formattedDate = dayjs
            .utc(value)
            .tz(dayjs.tz.guess())
            .format("YYYY-MM-DD HH:mm:ss");
          return formattedDate;
        },
      },
      {
        field: "actions",
        headerName: I18n.get("Actions"),
        width: 200,
        sortable: false,
        filterable: false,
        renderCell: (params) => {
          const isPermissionButtonDisabled =
            params.row.user_profile === "SuperAdmin";
          const isPermissionEditProfile =
            groupNameSel === "Admin" && isPermissionButtonDisabled;

          // Nuova condizione per disabilitare i bottoni
          const isCurrentUser = params.row.user_email === userInfo.email;

          return (
            <>
              <Tooltip title={I18n.get("Edit Profile")}>
                <IconButton
                  aria-label="edit"
                  onClick={() => {
                    setSelectedUser(params.row);
                    setEditUserOpen(true);
                  }}
                  disabled={isPermissionEditProfile || isCurrentUser} // Condizione aggiunta
                >
                  <ManageAccountsIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title={I18n.get("Edit Permission")}>
                <IconButton
                  aria-label="edit"
                  onClick={() => {
                    if (!isPermissionButtonDisabled) {
                      setSelectedUser(params.row);
                      setPermissionOpen(true);
                    }
                  }}
                  disabled={isPermissionButtonDisabled || isCurrentUser} // Condizione aggiunta
                >
                  <VisibilityIcon />
                </IconButton>
              </Tooltip>
            </>
          );
        },
      },
    ],
    [setSelectedUser, setPermissionOpen, groupNameSel]
  ); // Add groupNameSel as a dependency here
  function getBrowserName() {
    const userAgent = navigator.userAgent;
    if (userAgent.includes("Firefox")) {
      return "Firefox";
    } else if (userAgent.includes("Edg")) {
      return "Edge";
    }
  }
  const browser = getBrowserName();
  // const darkMode = localStorage.getItem("darkMode") === "true";
  const renderToolbar = () => {
    return (
      <div ref={toolbarRef}>
        <Stack direction="row" alignItems="center" spacing={2}>
          <Typography variant="h5" mt={0.5} mb={1}>
            {I18n.get("Users List")} ({filters ? filteredRowsCount : totalCount}
            )
          </Typography>
        </Stack>
        <Stack
          direction={tableParentIsMD ? "column" : "row"}
          alignItems="center"
          justifyContent={tableParentIsMD ? "center" : "space-between"}
          spacing={2}
          sx={{ pb: 1 }}
        >
          <Stack
            direction={tableParentIsMD ? "column" : "row"}
            spacing={2}
            sx={{ width: "100%" }}
          ></Stack>
          <Input
            type="text"
            placeholder={I18n.get("Search")}
            onChange={searchChanged}
            fullWidth={tableParentIsMD}
            endAdornment={
              <InputAdornment position="end">
                <IconButton>
                  <SearchIcon />
                </IconButton>
              </InputAdornment>
            }
          />
        </Stack>
      </div>
    );
  };
  useEffect(() => {
    if (browser === "Firefox") {
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = "auto";
      };
    }
  }, []);
  const [tableHeight, setTableHeight] = useState(0);
  useEffect(() => {
    const updateHeight = () => {
      const navbarHeight = document.getElementById("navbar");
      const footerHeight = document.getElementById("footer");
      const availableHeight =
        document.documentElement.clientHeight -
        navbarHeight -
        footerHeight -
        90;
      setTableHeight(availableHeight);
    };

    updateHeight();
    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
  }, []);

  return (
    <>
      <DashboardLayout>
        <DashboardNavbar
          absolute
          light
          language={language}
          setLanguage={setLanguage}
        />

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box sx={{ p: 2, maxHeight: `${tableHeight}px` }}>
              {" "}
              {/** lasciare così */}
              <Card
                sx={{
                  p: 3,
                  maxHeight: `${tableHeight}px`,
                }}
              >
                {renderToolbar()}

                <DataGridPro
                  localeText={
                    language === "it"
                      ? itIT.components.MuiDataGrid.defaultProps.localeText
                      : language === "ge"
                      ? deDE.components.MuiDataGrid.defaultProps.localeText
                      : ""
                  }
                  rows={filteredRows}
                  columns={columns}
                  getRowId={(row) => row.user_id}
                  rowModesModel={rowModesModel}
                  onRowModesModelChange={(newModel) =>
                    setRowModesModel(newModel)
                  }
                  onColumnVisibilityModelChange={handleColumnVisibilityChange}
                  initialState={{
                    density: "compact",
                    pinnedColumns: { right: ["actions"] },
                    sorting: {
                      sortModel: [{ field: "user_email", sort: "asc" }],
                    },
                  }}
                  apiRef={apiRef}
                  // pagination
                  hideFooter
                  sx={{
                    "& .MuiDataGrid-root, & .MuiDataGrid-footerContainer": {
                      minHeight: "2rem",
                    },
                    "&  .MuiDataGrid-cell ": {
                      cursor: "default",
                    },
                    borderColor: darkMode ? "#6B635A" : "#e0e0e0",
                    "& .MuiDataGrid-cell, &.MuiDataGrid-columnHeaders": {
                      borderColor: darkMode ? "#625a52" : "#e0e0e0",
                    },
                    "& .MuiDataGrid-columnSeparator": {
                      borderColor: darkMode ? "#625a52" : "#e0e0e0",
                    },
                    "--DataGrid-rowBorderColor": darkMode ? "#625a52" : "#e0e0e0",
                    minHeight: "20vh",
                    flexFlow: 1,
                    height: "100%",
                  }}
                  autoPageSize
                  resizeThrottleMs={resizeThrottle}
                  loading={!state.fetched || resizeThrottle > 60}
                  slotProps={{
                    loadingOverlay: {
                      variant: "skeleton",
                      noRowsVariant: "skeleton",
                    },
                  }}
                  slots={{
                    toolbar: () => (
                      <GridToolbarContainer>
                        <GridToolbarColumnsButton />
                        <GridToolbarExport
                          printOptions={{ disableToolbarButton: true }}
                          csvOptions={{
                            fileName: "User List",
                            utf8WithBom: true,
                          }}
                        />
                        <GridToolbarFilterButton />
                      </GridToolbarContainer>
                    ),
                  }}
                />
              </Card>
            </Box>
          </Grid>
        </Grid>
      </DashboardLayout>
      {selectedUser && (
        <EditUser
          open={editUserOpen}
          onClose={() => {
            setEditUserOpen(false);
            tlmGetAllUsers();
          }}
          userData={selectedUser}
          onSave={handleSaveUser}
          profileUser={profileUser}
          setProfileUser={setProfileUser}
        />
      )}
      {editPermissionOpen && (
        <EditPermission
          open={editPermissionOpen}
          onClose={() => {
            setPermissionOpen(false);
          }}
          userData={selectedUser}
          onSave={handleSaveUser}
          profileUser={profileUser}
          setProfileUser={setProfileUser}
        />
      )}
    </>
  );
};
export default Profile;
